export const getTextContentFromHTML = (value: string) => {
    const matches = value.match(/>(?!\\n)(?!\\r).*?(?=<)/g);
    const textContent = matches?.filter((string) => /\S/.test(string) && string !== '>');

    return textContent?.map((string) => string?.slice(1)) || [];
};
